import React, { Component } from "react"
import { observer } from "mobx-react"
import { Switch, Redirect } from "react-router"
import { BrowserRouter, Route, Link } from "react-router-dom"
import { authStore } from "../stores"
import styled from "styled-components"
import moment from "moment"
import OrderList from "./OrderList"
import { Icon, AppHeader, AppPanel, AppSidebar } from "./../lib"

export default class Orders extends Component {
  render() {
    return (
      <div>
        <AppHeader>
          <h1>Orders</h1>
        </AppHeader>
        <AppPanel>
          <Switch>
            <Route path="/orders" exact component={OrderList} />
            <Route path="/orders/:orderId" component={Order} />
          </Switch>
        </AppPanel>
      </div>
    )
  }
}

@observer
export class Order extends Component {
  render() {
    var { orderId } = this.props.match.params
    var purchase = authStore.purchases.get(orderId)
    if (!purchase) {
      return null
    }

    return (
      <div>
        <Link to="/orders"> ‹ Back to Orders</Link>
        <h4>Total: ${purchase.total}</h4>
        <p>Your profit: ${purchase.sellerProfit}</p>
        <p>{moment(purchase.time).fromNow()}</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/orders/Orders.js